import React, { useEffect, useState } from "react";
import Attachment from "../../asset/images/attachment.svg";
import { Client_Search, Help_Guide } from "../../Configuration/API_URL";
import { Constants } from "../../CommonMethhods/Constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoaderForSearch from "../Common/LoaderForSearch";
import { useDebounce } from "../useDebounce";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  AESEncryption,
  ApiResDecrypt,
  mobileVal,
} from "../../CommonMethhods/CommonMethods";
import axiosInstance, { axiosMultipartInstance } from "../../CommonMethhods/axiosInstance";

function WriteToUs() {
  const storeToken = localStorage.getItem("ssoToken");
  const [count, setCount] = useState();
  const [clientCode, setClientCode] = useState("");
  const [show, setShow] = useState(false);
  const [nameError, setNameError] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);

  const debouncedValue = useDebounce(clientCode, 1000);
  useEffect(() => {
    handleClientName(debouncedValue);
  }, [debouncedValue]);

  const writeToUsSchema = Yup.object().shape({
    clientCodeValid: Yup.string().required("*Please select valid Client Code"),
    mobileNoValid: Yup.string()
      .required("*Please Enter Mobile Number")
      .matches(/^[6-9]{1}[0-9]{9}$/, "Mobile Number should be 10 digits"),
    msgBoxValid: Yup.string().required("*Required Field"),
    fileValid: Yup.mixed().notRequired(),
  });
  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: yupResolver(writeToUsSchema),
  });

  const clientSupportApi = async (data) => {
    const storeToken = localStorage.getItem("ssoToken");

    try {
      const formData = new FormData();
      formData.append("ClientName", data.clientCodeValid);
      formData.append("AlternateNo", data.mobileNoValid);
      formData.append("Message", data.msgBoxValid);
      formData.append("File", data.fileValid[0] || "");

      const supportData = await axiosMultipartInstance.post(
        Help_Guide.Client_Support_URL,
        formData,
      );
      const res = supportData?.data;
      if (res?.status === 0) {
        toast.success(res?.data);
        clearErrors();
      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // for Client Name search

  async function searchApiDetail(code, NoPage) {
    let payloadValue = {
      keyword: code,
      Status: "",
      PageNo: NoPage,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axiosInstance.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
      );

      const res = ApiResDecrypt(getSearchDetail?.data);
      if (res?.status === 0) {
        setCount(res?.data?.TotalCount);
        setNameError(false);
        if (page > 1) {
          setClientList((prev) => {
            return [...prev, ...res?.data?.clients];
          });
        } else {
          setClientList(res?.data?.clients);
        }
      } else {
        setNameError(res?.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setScrollLoader(false);
    }
  }

  function handleClientName(data) {
    if (data) {
      searchApiDetail(data, 1);
      setScrollLoader(true);
      setClientList([]);
      setPage(1);
    }
  }

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
      }
    }
  };

  useEffect(() => {
    if (page > 1) {
      searchApiDetail(clientCode, page);
    }
  }, [page]);

  const OnfileSubmit = (data) => {
    clientSupportApi(data);
  };

  return (
    <div className="card-box">
      <div className="card-title">
        <h2>{Constants.Write_to_Us}</h2>
      </div>
      <form onSubmit={handleSubmit(OnfileSubmit)}>
        <div className="row">
          <div className="input-fields col-md-6 col-12">
            <label className="input-label align-self-center">
              {Constants.Client_Name_Code}
            </label>
            <div className="w-50">
              <div
                className={`rm-custom-dropdown ${
                  errors?.clientCodeValid?.message ? "border border-danger" : ""
                }`}
              >
                <input
                  type="text"
                  name="search-text"
                  className="input-st"
                  placeholder="Search by Name/Code..."
                  autoComplete="off"
                  value={clientCode}
                  onInput={(e) => {
                    const start = e.target.selectionStart;
                    const end = e.target.selectionEnd;

                    let input = e.target.value.toUpperCase();
                    input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                            input = input.replace(/\s{2,}/g, " "); 
                            input = input.replace(/^\s+/, ""); 

                    if (input.length > 100) input = input.slice(0, 100);
                    e.target.value = input;
                    e.target.setSelectionRange(start, end);
                  }}
                  onChange={(e) => {
                    setClientCode(e.target.value.toUpperCase());
                    setShow(true);
                    setValue("clientCodeValid", "");
                  }}
                />
                <button
                  type="button"
                  className="rm-dropdown-btn"
                  onClick={() => setShow(!show)}
                >
                  <span className="icon-right-arrow-triangle"></span>
                </button>
                {show && (
                  <>
                    <ul
                      className="rm-mapping-ap border-0"
                      onScroll={(e) => handleScroll(e)}
                    >
                      {clientList &&
                        clientList.map((item, i) => (
                          <li
                            key={i}
                            className="rm-maping-item-wrapper"
                            onClick={() => {
                              setClientCode(item?.clientCode);
                              setShow(false);
                              clearErrors("clientCodeValid");
                              setValue("clientCodeValid", item?.clientCode);
                            }}
                          >
                            <div> {item?.clientname}</div>
                            <div> {item?.clientCode}</div>
                          </li>
                        ))}
                      {scrollLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                      {nameError && !scrollLoader && (
                        <li
                          className="rm-maping-item-wrapper"
                          style={{
                            borderBottom: "none",
                            fontSize: "12px",
                          }}
                        >
                          {nameError}
                        </li>
                      )}
                    </ul>
                  </>
                )}
              </div>
              <span className="forget-link">
                {errors?.clientCodeValid?.message}
              </span>
            </div>
          </div>
          <div className=" col-md-6 col-12">
            <div className="input-fields">
              <label className="input-label align-self-center">
                {Constants.Alternate_No}
              </label>
              <div
                className={`input-text-wrapper ${
                  errors?.mobileNoValid?.message ? "border border-danger" : ""
                }`}
              >
                <input
                  type="text"
                  maxLength={10}
                  className="input-text"
                  autoComplete="off"
                  placeholder="Enter 10 digit Mobile No"
                  {...register("mobileNoValid")}
                  onKeyPress={(e) => mobileVal(e)}
                />
              </div>
            </div>
            <span className="forget-link">
              {errors?.mobileNoValid?.message}
            </span>
          </div>

          <div className="input-fields height-formsg col-12">
            <label className="input-label input-formsg">
              {Constants.Message}
            </label>
            <div
              className={`input-text-wrapper for-wrapper-widht flex-column align-items-end message-wrapper ${
                errors?.msgBoxValid?.message ? "border border-danger" : ""
              }`}
            >
              <textarea
                id="msg1"
                cols={20}
                rows={5}
                {...register("msgBoxValid")}
                className="input-text"
              />
              <span className="forget-link">
                {errors?.msgBoxValid?.message}
              </span>
            </div>
          </div>
          <div className="w-100 d-flex justify-content-end">
            <label className="filelabel">
              <span className="clientfile">
                {Constants.Attachment}
                <img src={Attachment} alt="attachment" className />
              </span>
              <input
                className="clientfile"
                id="fileclient"
                name="booking_attachment"
                type="file"
                {...register("fileValid")}
              />
            </label>
          </div>
        </div>
        <input
          type="submit"
          defaultValue="Send Message"
          className="send-message"
        />
      </form>
    </div>
  );
}

export default WriteToUs;
